import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import './conference.css';
import Spinner from './spinner';
import * as serviceWorker from './serviceWorker';

import $ from 'jquery';
import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { en, fr, es, it } from "make-plural/plurals"
import { messages as localeEn } from './locales/en/messages.js'
import { messages as localeFr } from './locales/fr/messages.js'
import { messages as localeEs } from './locales/es/messages.js'
import { messages as localeIt } from './locales/it/messages.js'
import config from './config';
import { getLinkData } from './webServices';

i18n.loadLocaleData ( "fr", { plurals: fr } );
i18n.loadLocaleData ( "en", { plurals: en } );
i18n.loadLocaleData ( "es", { plurals: es } );
i18n.loadLocaleData ( "it", { plurals: it } );

i18n.load ( {
    fr: localeFr,
    en: localeEn,
    es: localeEs,
    it: localeIt
 } );

// Fontawesome initialisation
library.add ( fas );

const $root = $( '#root' ),
      key = $root.data ( 'key' ),
      lang = $root.data ( 'language' ),
      domain = $root.data ( 'domain' ),
      soundUrl = $root.data ( 'sound-url' ),
      logoUrl = $root.data ( 'logo-url' ),
      backgroundUrl = $root.data ( 'background-image-url' ),
      backgroundRepeat = $root.data ( 'background-image-repeat' ),
      linkelloUrl = $root.data ( 'linkello-url' ),
      videoBgImgUrls = $root.data ( 'video-bg-image-url' ),
      videoWatermarkUrl = $root.data ( 'video-watermark-url' ),
      name = $root.data ( 'name' ),
      chat = $root.data ( 'chat' ),
      data = $root.data ( 'info' );

i18n.activate ( lang );

config.set ( {
    domain: domain,
    soundUrl: soundUrl,
    logoUrl: logoUrl,
    backgroundUrl: backgroundUrl,
    backgroundRepeat: backgroundRepeat,
    chat: chat,
    linkelloUrl: linkelloUrl,
    videoBgImgUrls: videoBgImgUrls.split ( "," ),
    videoWatermarkUrl: videoWatermarkUrl,
    name: name,
    lang: lang
} );

const loadActivity = data =>
{
    if ( data.link.type === 'conference' )
    {
        const Conference = lazy ( () => import ( './conference' ) );

        ReactDOM.render (
            <React.StrictMode>
                <I18nProvider i18n={i18n}>
                    <ReactNotification />
                    <Suspense fallback={<Spinner />}>
                        <Conference authorisations={data.authorisations} link={data.link} signaling={data.signaling} features={data.features}/>
                    </Suspense>
                </I18nProvider>
            </React.StrictMode>,
            $root.get ( 0 )
        );
    }
}

if ( data )
{
    loadActivity ( data );
}
else
{
    getLinkData ( key, loadActivity );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
